import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { Phones } from './PatientElements';
import { parseName, parsePhones } from '../utils';

var _ref = /*#__PURE__*/React.createElement(View, null);

export const PatientAssignments = ({
  assignments
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, defaults.assignedCareProviders), Array.isArray(assignments) ? assignments.map(assignment => assignment.type ? /*#__PURE__*/React.createElement(Assignment, {
  assignment: assignment,
  key: `${assignment.name}-${assignment.type}`
}) : _ref) : /*#__PURE__*/React.createElement(Assignment, {
  assignment: assignments
}));

var _ref2 = /*#__PURE__*/React.createElement(View, null);

var _ref3 = /*#__PURE__*/React.createElement(View, null);

const Assignment = ({
  assignment
}) => {
  const name = parseName(assignment);
  const phones = parsePhones(assignment);
  return /*#__PURE__*/React.createElement(View, null, assignment.type !== 'DNR' ? /*#__PURE__*/React.createElement(View, {
    style: [styles.row, styles.width100, styles.justifyContentCenter]
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.width30]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, `${assignment.type}`)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width20]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, name)), /*#__PURE__*/React.createElement(View, {
    style: styles.width40
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, `${assignment.email}`)), /*#__PURE__*/React.createElement(View, {
    style: styles.width20
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, phones ? /*#__PURE__*/React.createElement(Phones, {
    phones: phones
  }) : _ref2))) : _ref3);
};